import MemberDashboardIcon from "@mui/icons-material/AccountBox";
import NewsIcon from "@mui/icons-material/Announcement";
import CoachIcon from "@mui/icons-material/AssignmentInd";
import BrandingIcon from "@mui/icons-material/Brush";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SeasonIcon from "@mui/icons-material/DynamicFeed";
import SportIcon from "@mui/icons-material/Grain";
import SubscriptionIcon from "@mui/icons-material/GroupAdd";
import ChartIcon from "@mui/icons-material/InsertChart";
import SponsorIcon from "@mui/icons-material/LocalAtm";
import MenuIcon from "@mui/icons-material/Menu";
import MessageIcon from "@mui/icons-material/Message";
import TeamIcon from "@mui/icons-material/People";
import TrainingIcon from "@mui/icons-material/PermContactCalendar";
import ResponsiveIcon from "@mui/icons-material/Phonelink";
import SiteIcon from "@mui/icons-material/Public";
import PostIcon from "@mui/icons-material/RateReview";
import CustomPagesIcon from "@mui/icons-material/Receipt";
import MemberIcon from "@mui/icons-material/SupervisorAccount";
import GdprIcon from "@mui/icons-material/VerifiedUser";
import LandingIcon from "@mui/icons-material/ViewDay";
import AutoPagesIcon from "@mui/icons-material/ViewModule";
import PageDesignerIcon from "@mui/icons-material/ViewQuilt";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/system";
import { BG_DARK_TEXT } from "consts/colors";
import { useTranslation } from "react-i18next";
import FeatureItem from "./FeatureItem";
import MemberFeatures from "./MemberFeatures";

const titleStyle = {
  py: 5,
};

const MoreButton = (props) => {
  const { t, ...propsRest } = props;
  return (
    <Button
      {...propsRest}
      variant="outlined"
      color="info"
      sx={{
        borderRadius: 30,
        minWidth: 180,
        height: 60,
        margin: (theme) => theme.spacing(2),
      }}
    >
      {t("View More", { ns: "translation" }) }
    </Button>
  );
};

const Features = () => {
  const { t } = useTranslation(["features", "translation"]);

  return (
    <>
      {/* <Box sx= {{
         backgroundColor: theme.palette.primary.main, 
      }}>
        <Button
          className={classes.button}
          variant="outlined"
          color="secondary"
          component={RouterLink}
          to={"/demo"}
        >
          Demo
        </Button>
      </Box> */}
      <Box
        component="section"
        id="architecture"
        sx={{
          paddingTop: (theme) => theme.spacing(8),
          paddingBottom: (theme) => theme.spacing(8),
          backgroundColor: (theme) => theme.palette.primary.main, // "#3c3a3a", //theme.palette.secondary.main,
          color: "white",
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h2" sx={{ color: BG_DARK_TEXT }}>
            {t("Our Key Services")}
          </Typography>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg:4 }}>
              <FeatureItem
                size={"large"}
                icon={DashboardIcon}
                title={t("Backend Dashboard")}
                text={t("backend_dashboard_text")}
              />
              <MoreButton href="#backend" t={t} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg:4 }}>
              <FeatureItem
                size={"large"}
                icon={SiteIcon}
                title={t("Frontend web site")}
                text={t("frontend_web_site_text")}
              />
              <MoreButton href="#frontend" t={t} />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, lg:4 }}>
              <FeatureItem
                size={"large"}
                icon={MemberDashboardIcon}
                title={t("Member dashboard")}
                text={t("member_dashboard_text")}
              />
              <MoreButton href="#member-backend" t={t} />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <section id="backend">
        <Container maxWidth="lg">
          <Typography variant="h2" sx={{ ...titleStyle }}>
            {t("Backend Features")}
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={MemberIcon}
                title={t("Members")}
                text={t("Add new members, adult athletes  children, parent-child management easily")}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={SubscriptionIcon}
                title={t("Subscriptions", { ns: "translation" })}
                text={
                  "Manage member subscriptions easily, collect payments, monitor overdue status and send overdue notifications"
                }
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={MessageIcon}
                title={t("Messaging")}
                text={
                  "Instant communication with members, send sms or emails, target all or specific members, teams, sports"
                }
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={SportIcon}
                title={t("Sports", { ns: "translation" })}
                text={t("Multiple sports supported out of the box")}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={SeasonIcon}
                title={t("Seasons", { ns: "translation" })}
                text={
                  "Create multiple seasons for all sports or per sport, easily import data from previous seasons to avoid extra work, monitor your sport club per season"
                }
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={TeamIcon}
                title={t("Teams", { ns: "translation" })}
                text={"Create and edit your teams, manage roster, team continuation in new season"}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={CoachIcon}
                title={t("Coaches", { ns: "translation" })}
                text={"Manage coaches, assign them to teams, coach continuation in new season"}
              />
            </Grid>

            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={TrainingIcon}
                title={t("Trainings & Attendance")}
                text={
                  "Manage trainings of your teams and track attendance of your athletes, send attendace notifications to members"
                }
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={ChartIcon}
                title={t("Charts & statistics")}
                text={"Overview sport club status through time with usefull charts and statistics"}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={PostIcon}
                title={t("Integrated CMS")}
                text={
                  "Create and manage media-rich posts, news, announcements or create custom pages for your web site."
                }
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={PageDesignerIcon}
                title={t("Page designer")}
                text={"Create custom landing page and news page using built-in page designer"}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={SponsorIcon}
                title={t("Sponsors")}
                text={"Manage sponsors of your academy and present them in frontend site"}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={GdprIcon}
                title={t("GDPR compatible")}
                text={"The application takes into consideration the latest rules for personal data of users"}
              />
            </Grid>
          </Grid>
        </Container>
      </section>
      <section id="frontend">
        <Container maxWidth="lg">
          <Typography variant="h2" sx={{ ...titleStyle }}>
            {t("Frontend Features")}
          </Typography>
          <Grid container direction="row" alignItems="flex-start" justifyContent="center" style={{ minHeight: "20vh" }}>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={ResponsiveIcon}
                title={t("Modern and responsive")}
                text={t(
                  "Web site is using modern design guidelines and it is fully responsive and compatible with all devices"
                )}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={LandingIcon}
                title={t("Landing page")}
                text={t(
                  "Showcase your sport club features with sliders, thumbnails, images. Use the page designer to create custom landing page."
                )}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={NewsIcon}
                title={t("News/blog page")}
                text={t(
                  "Post latest news and emphasize important news with featured news slider. Use the page designer to create custom news page"
                )}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={MenuIcon}
                title={t("Main menu")}
                text={t("Use the autogenerated menu or design your own from scratch")}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={AutoPagesIcon}
                title={t("Sport, teams, roster and coaches pages")}
                text={t(
                  "Special auto-generated pages for sport, teams, roster and coaches. Control personal data display"
                )}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={BrandingIcon}
                title={t("Branding")}
                text={t("Add your logo image and customize colors to your preference")}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={CustomPagesIcon}
                title={t("Custom pages and sections")}
                text={t("Create custom pages and sections by using the integrated CMS and section creator")}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3
              }}>
              <FeatureItem
                icon={SponsorIcon}
                title={t("Sponsors")}
                text={t("Display sponsors in various places in the home page and in special sponsor page")}
              />
            </Grid>
          </Grid>
        </Container>
      </section>
      <MemberFeatures />
      <Grid container direction="row" alignItems="center" justifyContent="center">
        <Grid style={{ marginTop: 30, marginBottom: 50 }} size={12}>
          {/* <Button
          color="secondary"
          size="large"
          variant="contained"
          className={classes.button}
          component="a"
          href="/explore"
        >
          Discover more...
        </Button> */}
        </Grid>
      </Grid>
    </>
  );
};

export default Features;
